<template>
    <div class="q-pa-md" >
        <div class="position-absolute" style="right: 15px;top:75px; z-index: 1">
            <div class="d-flex">
                <q-input class="searchBox" debounce="300" placeholder="Search" style="width: 350px"
                         v-model="filter">
                    <template v-slot:prepend>
                        <q-icon name="search"/>
                    </template>
                </q-input>

            </div>
        </div>
        <q-tabs class="text-primary" align="left" style="padding-left: 16px;padding-right: 16px" v-model="tab">
            <q-tab :label="tab.label+' ('+tab.count+')'" :name="tab.component" :key="index"
                   class="text-blue" v-for="(tab, index) in tabArr"></q-tab>

        </q-tabs>
        <q-separator></q-separator>

        <new-request :filter="filter" @ordersCount="tabArr[0].count=$event" ref="NewRequest"
                     v-show="tab==='NewRequest'"></new-request>
        <due-inventory :filter="filter" @ordersCount="tabArr[1].count=$event" ref="DueInventory"
                       v-show="tab==='DueInventory'"></due-inventory>
        <paid-inventory-purchase :filter="filter" @ordersCount="tabArr[2].count=$event" ref="PaidInventoryPurchase"
                       v-show="tab==='PaidInventoryPurchase'"></paid-inventory-purchase>

    </div>
</template>

<script>

    import NewRequest from '../ManageStock/NewRequest'
    import PaidInventoryPurchase from '../ManageStock/PaidInventoryPurchase'
    import DueInventory from '../ManageStock/DueInventory'


    export default {
        name: 'Purchase',
        components: {
            NewRequest,
            PaidInventoryPurchase,
            DueInventory,
        },
        data: function () {
            return {
                tab: 'NewRequest',
                filter: '',
                tabArr: [
                    { label: 'Incoming', component: 'NewRequest', count: 0 },
                    { label: 'Due', component: 'DueInventory', count: 0 },
                    { label: 'Paid', component: 'PaidInventoryPurchase', count: 0 }
                ],

            }
        },
        methods:{
            onWinScroll(){
                if ((window.innerHeight + window.scrollY + 80) >= document.body.offsetHeight) {
                    this.$refs[this.tab].fetchMoreOrders()
                }
            }
        },
        mounted() {
            window.addEventListener('scroll', this.onWinScroll)
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.onWinScroll)
        },
    }
</script>

<style scoped>

</style>
